<template>
    <div>
        <el-card>
            <nav class="input" style="width: auto">
                <el-input
                    v-model="search.keyword"
                    size="medium"
                    placeholder="券名称、说明"
                    clearable
                    @keyup.enter.native="subimt"
                />
            </nav>
            <nav class="input" style="width: auto">
                <el-select
                    v-model="search.status"
                    placeholder="状态"
                    size="medium"
                    clearable
                >
                    <el-option label="全部" :value="''" />
                    <el-option label="启用" :value="0" />
                    <el-option label="停止" :value="1" />
                </el-select>
            </nav>
            <nav class="input" style="width: 150px">
                <el-button size="small" @click="reset">重置</el-button>
                <el-button type="primary" size="small" @click="subimt"
                    >搜索</el-button
                >
            </nav>
            <nav class="input" style="width: auto">
                <el-button type="primary" size="small" @click="add"
                    >创建合作道具券</el-button
                >
            </nav>
        </el-card>

        <el-card style="margin-top: 10px">
            <el-table
                :data="list"
                style="width: 100%"
                border
                stripe
                :header-cell-style="rowClass"
            >
                <el-table-column prop="id" label="ID" width="80" />
                <el-table-column prop="title" label="券名称" min-width="140" />
                <el-table-column prop="value" label="道具数值" width="100">
                    <template slot-scope="{ row }">
                        {{ row.value
                        }}{{ isRefreshPropByName(row.propName) ? '次' : '天' }}
                    </template>
                </el-table-column>
                <el-table-column prop="propName" label="道具类型" width="120">
                    <template slot-scope="{ row }">
                        {{ row.propName || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="limit" label="每人限领" width="90">
                    <template slot-scope="{ row }">
                        {{ row.limit == 0 ? '不限' : row.limit }}
                    </template>
                </el-table-column>
                <el-table-column label="有效期" min-width="160">
                    <template slot-scope="{ row }">
                        {{
                            row.isTerm == 2
                                ? '永久'
                                : row.propEndTime || '-'
                        }}
                    </template>
                </el-table-column>
                <el-table-column label="使用/领取/总数" width="130">
                    <template slot-scope="{ row }">
                        {{
                            `${row.useNum || 0}/${row.receiveNum || 0}/${
                                row.number || 0
                            }`
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="sunCode" label="二维码" width="100">
                    <template slot-scope="{ row }">
                        <el-image
                            v-if="row.sunCode"
                            style="width: 80px"
                            :src="baseurl + yu + row.sunCode"
                            :preview-src-list="[baseurl + yu + row.sunCode]"
                        />
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="desc"
                    label="说明"
                    min-width="120"
                    show-overflow-tooltip
                />
                <el-table-column prop="createTime" label="创建时间" width="160" />
                <el-table-column prop="status" label="状态" width="90">
                    <template slot-scope="{ row }">
                        <el-tag :type="row.status ? 'warning' : 'success'">{{
                            row.status ? '停止' : '启用'
                        }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" fixed="right">
                    <template slot-scope="{ row }">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            size="mini"
                            style="color: skyblue"
                            @click="editor(row)"
                            >编辑</el-button
                        >
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            size="mini"
                            style="color: red"
                            @click="deletes(row)"
                            >删除</el-button
                        >
                        <el-button
                            type="text"
                            icon="el-icon-s-promotion"
                            size="mini"
                            style="color: pink"
                            @click="shelves(row)"
                            >{{ row.status == 0 ? '停用' : '启用' }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                :current-page="search.page"
                background
                :page-sizes="[3, 5, 10, 15]"
                :page-size="search.pageSize"
                layout="total, prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
            />
        </el-card>
        <Drawers ref="drawer" @getlist="onList" />
    </div>
</template>

<script>
import list from '/src/mixin/list.js'

export default {
    mixins: [list],
    data() {
        return {
            search: {
                keyword: '',
                status: '',
                page: 1,
                pageSize: 10,
            },
        }
    },
    created() {
        this.getlist()
    },
    methods: {
        isRefreshPropByName(name) {
            return (name || '').includes('刷新')
        },
        add() {
            this.$refs.drawer.editId = null
            this.$refs.drawer.title = '添加合作道具券'
            this.$refs.drawer.interfaces = 16
            this.$refs.drawer.ruleForm = {
                title: '',
                propId: '',
                value: 1,
                number: 0,
                limit: 0,
                desc: '',
                isTerm: 2,
                endTime: '',
            }
            this.$refs.drawer.drawer = true
        },
        async editor(row) {
            const { data: res } = await this.$http.get(
                '/admin/CooperationPropCoupon/getById?id=' + row.id
            )
            if (res.errorCode != 200) return
            const data = res.data || {}
            this.$refs.drawer.ruleForm = {
                ...data,
                id: data.id || row.id,
                propId:
                    data.propId != null && data.propId !== ''
                        ? data.propId * 1
                        : row.propId != null && row.propId !== ''
                        ? row.propId * 1
                        : '',
                propName: data.propName || row.propName || '',
                value: Number(data.value) || 1,
                number: Number(data.number) || 0,
                limit: Number(data.limit) || 0,
                isTerm: Number(data.isTerm) || 2,
                endTime: data.propEndTime || data.endTime || '',
            }
            this.$refs.drawer.editId = row.id
            this.$refs.drawer.title = '修改合作道具券'
            this.$refs.drawer.interfaces = 16
            this.$refs.drawer.drawer = true
        },
        async deletes(row) {
            try {
                await this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                const { data: res } = await this.$http.delete(
                    '/admin/CooperationPropCoupon/delete',
                    {
                        params: { id: row.id },
                    }
                )
                if (res.errorCode == 200) {
                    this.$message.success(res.message)
                    if (this.list.length === 1 && this.search.page > 1) {
                        this.search.page--
                    }
                    this.getlist()
                }
            } catch (error) {
                this.$message({
                    type: 'info',
                    message: '已取消删除',
                })
            }
        },
        async shelves(row) {
            const { data: res } = await this.$http.post(
                '/admin/CooperationPropCoupon/updateStatus',
                {
                    id: row.id,
                    status: row.status ? 0 : 1,
                }
            )
            if (res.errorCode == 200) {
                this.$message.success(res.message)
                this.getlist()
            }
        },
        handleCurrentChange(e) {
            this.search.page = e
            this.getlist()
        },
        onList() {
            this.getlist()
        },
        async getlist() {
            const { data: res } = await this.$http.get(
                '/admin/CooperationPropCoupon/getList',
                {
                    params: {
                        ...this.search,
                    },
                }
            )
            if (res.errorCode == 200) {
                this.list = res.data.list || []
                this.total = res.data.totalCount || 0
            }
        },
        subimt() {
            this.search.page = 1
            this.getlist()
        },
    },
}
</script>
